export default __webpack_public_path__ + "static/media/check-unchecked.34d1393f.svg";